<template>
  <div class="progress_wrapper">
      <div class="progress_bar" :style="{width: this.current + '%'}">
          <div class="innerbar">
              <span>{{ innerBar }}</span>
          </div>
      </div>
      <div class="outerbar" :style="{width: (100 - this.current) + '%'}" v-if="outerBar !== ''"><span>{{ outerBar }}</span></div>
  </div>
</template>

<script>
export default {
    props: {
        current: {
            type: Number,
            default: 0,
            validator: (value) => {
                return value >= 0 && value <= 100;
            }
        },
        innerBar: {
            type: String,
            default: ""
        },
        outerBar: {
            type: String,
            default: ""
        }
    },
    computed: {
        
    }
}
</script>

<style scoped>
.progress_wrapper {
    width: 100%;
    background: rgb(49, 49, 49);
    padding: 6px;
}
.progress_bar {
    height: 30px;
    background: white;
    text-align: center;
    text-overflow: ellipsis;
    display: inline-block;
}
.outerbar {
    display: inline-block;
    text-align: center;
    height: 30px;
}
.innerbar {
    color: black;
}

.innerbar span, .outerbar span {
    margin-top: 5px;
}
</style>